import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

export function QueueSection({
	title,
	subtitle,
	tone = "default",
	actions,
	children,
}: {
	title: string;
	subtitle?: string;
	tone?: "default" | "coral";
	actions?: ReactNode;
	children: ReactNode;
}) {
	return (
		<section
			className={cn("surface-panel", tone === "coral" ? "border-destructive/40" : "border-border")}
		>
			<header
				className={cn(
					"flex flex-wrap items-baseline justify-between gap-x-3 gap-y-1 border-b px-4 py-3",
					tone === "coral" ? "border-destructive/30" : "border-border",
				)}
			>
				<h2 className="type-section-title text-foreground">{title}</h2>

				<span className="flex items-center gap-2">
					{subtitle !== undefined && (
						<span className="text-xs text-muted-foreground">{subtitle}</span>
					)}

					{actions}
				</span>
			</header>

			{children}
		</section>
	);
}

export function QueueRow({ children, className }: { children: ReactNode; className?: string }) {
	return (
		<div className={cn("border-b border-border/60 px-4 py-3 last:border-b-0", className)}>
			{children}
		</div>
	);
}

export function MetaLine({ children, className }: { children: ReactNode; className?: string }) {
	return (
		<div
			className={cn(
				"flex items-center overflow-hidden whitespace-nowrap text-xs leading-tight text-muted-foreground",
				"[&>*+*]:ml-2 [&>*+*]:border-l [&>*+*]:border-border [&>*+*]:pl-2",
				className,
			)}
		>
			{children}
		</div>
	);
}
